export interface ThemeConfig {
  primary: string;
}

export const themes: Record<string, ThemeConfig> = {
  jca: { primary: '#e34615' },
  tecnoma: { primary: '#00A651' }
};

export function getTheme(): ThemeConfig {
  const themeName = process.env.VUE_APP_THEME || 'jca';
  return themes[themeName] || themes.jca;
}

export function getThemeName(): string {
  return process.env.VUE_APP_THEME || 'jca';
}
